import StaticPageRedirect from '../component/StaticPageRedirect';
export default function Help() { return <StaticPageRedirect page="help" />; }
